import { render, staticRenderFns } from "./MTAbnormalDisplay.vue?vue&type=template&id=f4b642d6&scoped=true&"
import script from "./MTAbnormalDisplay.vue?vue&type=script&lang=js&"
export * from "./MTAbnormalDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MTAbnormalDisplay.vue?vue&type=style&index=0&id=f4b642d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b642d6",
  null
  
)

export default component.exports